import { FC, useEffect, useState } from "react";
import styles from './envelope.module.css';
import { PostcardMenu } from "../PostcardMenu/PostcardMenu";
import { PostcardConstructor } from "../PostcardConstructor/PostcardConstructor";
import ImageContext from "../../services/ImageContext";
import snowman from '../../images/snowman.png'
import snowcapShadow from '../../images/snowcapWIthShadow.png'
import { mockGetVideo, mockSendPostcard, sendPostcard, getPostcard } from "../../utils/api";
import { Button } from "@mui/material";
import { Modal } from "../Modal/Modal";
import { Loading } from "../Loading/Loading";
import ym from "react-yandex-metrika";


export const Envelope:FC = () => {
    const [ imgNumber, setImgNumber ] = useState<number>(1)

    const [ isPostcard, setIsPostcard ] = useState<boolean>(true)
    const [ isSendPostcard, setIsSendPostcard ] = useState<boolean>(false)
    const [ croppedImages, setCroppedImages ] = useState<string[]>([]);
    const [ isButtonChoiceDisabled, setIsButtonChoiceDisabled ] = useState<boolean>(false)
    const [ isBtnSharePress, setIsBtnSharePress ] = useState<boolean>(false)

    const [videoUrl, setVideoUrl] = useState<string | null>(null);
    const [videoDownload, setVideoDownload] = useState<string | null>(null)

    const [modalResult, setModalResult] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(false)


    const handleTakePostcardMock = async () => {
        if (isPostcard) {
            setIsSendPostcard(true)
            console.log('Все правильно');
            setIsButtonChoiceDisabled(true);
            console.log({ imgNumber, croppedImages });
            localStorage.setItem('croppedImages', JSON.stringify(croppedImages));
            setIsLoading(true)
            setModalResult(true)
            const sendResponse = await mockSendPostcard(croppedImages);
            const crop = String(croppedImages.length);

            ym('reachGoal', 'take_postcard', { postcard: croppedImages.length });

            if (sendResponse.success) {
                console.log(sendResponse.token)
                const videoResponse = await mockGetVideo(sendResponse.token);
                if (videoResponse.result === 'done') {
                    setVideoUrl(videoResponse.video);
                    setIsLoading(false)
                    setModalResult(false)
                }
            }
        } else {
            console.log('Ошибка');
        }
    };

    const handleTakePostcard = async () => {
        if (isPostcard) {
            setIsSendPostcard(true)
            // console.log('Все правильно');
            setIsButtonChoiceDisabled(true);
            // console.log({ imgNumber, croppedImages });
            localStorage.setItem('croppedImages', JSON.stringify(croppedImages));
            const crop = String(croppedImages.length);
            const cropp = JSON.stringify(croppedImages.length)
            console.log(crop)

            ym('reachGoal', 'take_postcard', { postcard: croppedImages.length });
                // ym('95940102', 'reachGoal', {postcard: crop})

            try {
                // Отправляем фотографии на бэкенд
                const sendResponse = await sendPostcard(croppedImages);

                if (sendResponse.success) {
                    // console.log(sendResponse.token);
                    setIsLoading(true);
                    setModalResult(true)

                    // Функция для проверки статуса видео
                    const checkVideoStatus = async () => {
                        const videoResponse = await getPostcard(sendResponse.token);
                        if (videoResponse.result === 'done') {
                            ym('reachGoal', 'get_postcard');
                            setVideoUrl(videoResponse.video);
                            setVideoDownload(videoResponse.download)
                            setIsLoading(false);
                            setModalResult(false)
                            clearInterval(intervalId);
                        } else {
                            setIsLoading(true)
                            console.log('Статус видео еще не готов, повторяем запрос...');
                        }
                    };

                   // Интервал
                    const intervalId = setInterval(checkVideoStatus, 5000);
                }
            } catch (error) {
                console.error('Ошибка при отправке открытки или получении видео:', error);
                setIsLoading(false);
            }
        } else {
            console.log('Ошибка');
        }
    };


    const handleUploadVideo = () => {
        if (videoDownload) {
            ym('reachGoal','upload_video')
            const link = document.createElement('a');
            link.href = videoDownload;
            link.download = 'postcard.mp4';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        // setIsSendPostcard(false)
        // setVideoUrl(null)
        // setCroppedImages([])
        // setIsButtonChoiceDisabled(false)
        // setVideoDownload(null)
        // localStorage.clear()

        } else {
            console.log('Нет видео для скачивания');
        }
    };

    const handleTryAgain = () => {
        setIsSendPostcard(false)
        setVideoUrl(null)
        setCroppedImages([])
        setIsButtonChoiceDisabled(false)
        localStorage.clear()
    }

    // const handleUploadCroppedPhoto = () => {
    //     if (croppedImages.length > 0) {
    //         croppedImages.forEach((image, index) => {
    //             const link = document.createElement('a');
    //             link.href = image;
    //             link.download = `cropped_image_${index + 1}.png`;
    //             document.body.appendChild(link);
    //             link.click();
    //             document.body.removeChild(link);
    //         });
    //     } else {
    //         console.log('Нет изображений для загрузки');
    //     }
    // };

    const handleModalOpen = () => {
        setModalResult(true)
        setIsLoading(true)
    }

    const handleModalClose = () => {
        setModalResult(false)
    }

    const handleCopyUrl = () => {
        // const currentUrl = window.location.href;
        ym('reachGoal','share_url')
        navigator.clipboard.writeText('https://www.karusel-tv.ru/video-postcard-2025')
            .then(() => {
                setIsBtnSharePress(true)
            })
            .catch(err => {
                setIsBtnSharePress(false)
                console.error('Ошибка при копировании ссылки: ', err);
            });
    };
    return (
        <section className={styles.envelopeSection}>
        <img className={styles.snowcap} src={snowcapShadow} alt="Снег" />
        {
            isSendPostcard ? (
                <div className={styles.videoContainer}>
                    {
                        isLoading ? (
                            <div className={styles.loaderContainer}>
                                {/* <h2>Не&nbsp;закрывайте это окно, ваше видео создаётся и&nbsp;скоро будет доступно для просмотра и&nbsp;скачивания</h2>
                                <img className={styles.loader} src={loading} alt="Загрузка..." /> */}
                            </div>
                        ) : videoUrl && (
                                <div className={styles.videoContainer}>
                                    <video
                                    className={styles.video}
                                    controls
                                    muted
                                    autoPlay>
                                        <source src={videoUrl} type="video/mp4" />
                                        Ваш браузер не поддерживает видео.
                                    </video>
                                    <Button
                                        onClick={handleUploadVideo}
                                        variant="contained"
                                    >Скачать видео</Button>
                                    {/* <a 
                                    href="https://static.karusel-tv.ru/video-postcard-2025-dl/1t8zcbw7e7hirt1628779p18c1mcxpat.mp4"
>Скачать</a> */}
                                    <h2
                                    className={styles.title}
                                    >Ура, получилось! Обязательно сохраните ваше видео, так как мы&nbsp;не&nbsp;храним пользовательские данные на&nbsp;сервере.</h2>
                                    <Button
                                        onClick={handleCopyUrl}
                                        variant={isBtnSharePress ? 'outlined' : 'contained'}
                                    >{isBtnSharePress ? 'Ваша ссылка- скопирована!' : 'Поделиться' }</Button>
                                    <Button
                                        onClick={handleTryAgain}
                                        variant="contained"
                                    >Сделать ещё одну открытку</Button>
                                </div>
                            )
                    }
                </div>
            ) : (
                <ImageContext.Provider value={{ imgNumber, setImgNumber }}>
                    <PostcardMenu
                    croppedImages={croppedImages}
                    isButtonChoiceDisabled={isButtonChoiceDisabled}
                    getPostcard={handleTakePostcard} />
                    <PostcardConstructor
                        setIsPostcard={setIsPostcard}
                        setCroppedImages={setCroppedImages}
                        handleTakePostcard={handleTakePostcard}/>
                </ImageContext.Provider>
            )
        }
        {
            modalResult && (
                <Modal
                close={handleModalClose}
                isLoading={isLoading}
                >
                    <Loading />
                </Modal>
            )
        }
        <img
        className={styles.snowman}
        style={videoUrl ? {height: '225px'} : {}}
        src={snowman} 
        alt="Снеговик" />
    </section>
    )
}
